(function(){
    'use strict';
    angular.module('app').config(routesUrlConfig);

    routesUrlConfig.$inject = ['$routeProvider', '$locationProvider'];

    function routesUrlConfig($routeProvider, $locationProvider) {
        $routeProvider.
        when('/networking/:id', {
            templateUrl: '/templates/pages/networking/ResellerNetworkCarrierProfiles.html',
            controller: 'ResellerNetworkCarrierProfilesController',
            controllerAs: 'vm',
            params: {
                parent: 'networking',
                subParent: 'networking',
                htmlTitle: 'Network Effect - Reseller\'s Shared Carrier Profiles',
                pageTitle: 'Network Effect - Reseller\'s Shared Carrier Profiles',
                icon: 'fa fa-pencil'
            }
        }).
        when('/networking/:id/shared-services/:carrierProfileId', {
            templateUrl: '/templates/pages/networking/ResellerNetworkServiceProfiles.html',
            controller: 'ResellerNetworkServiceProfilesController',
            controllerAs: 'vm',
            params: {
                parent: 'networking',
                subParent: 'networking',
                htmlTitle: 'Network Effect - Reseller\'s Shared Service Profiles',
                pageTitle: 'Network Effect - Reseller\'s Shared Service Profiles',
                icon: 'fa fa-pencil'
            }
        });

        $locationProvider.html5Mode({
            enabled: true,
            requireBase: false
        });
    }
})();


// WEBPACK FOOTER //
// ./js/urls/networking.js